import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_ADMIN_TIME_OFF_REQUEST_TYPE_FILTERS,
  DEFAULT_EMPLOYEE_TIME_OFF_DATE_TYPE_FILTER,
  DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_STATUS_FILTERS,
  DEFAULT_TOR_ADMIN_SORT_MODEL
} from "../../util/filterTimeOffRequests";

const initialState = {
  dateTypeFilter: DEFAULT_EMPLOYEE_TIME_OFF_DATE_TYPE_FILTER,
  startDateFilter: null,
  endDateFilter: null,
  timeOffTypeFilters: DEFAULT_ADMIN_TIME_OFF_REQUEST_TYPE_FILTERS,
  statusFilters: DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_STATUS_FILTERS,
  searchString: "",
  adminTimeOffRequestFoundByReferenceNumberSearch: null,
  adminTimeOffRequestFoundByReferenceNumberSearchIsLoading: false,
  adminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  sortModel: DEFAULT_TOR_ADMIN_SORT_MODEL,
};

// The plan is that this slice will be the home of all trade related data in the client
// including the following:
//      - trade filter metadata
//      - trade list (future)
//      - filtered trade list (future)
//      - searched trade list (future)
export const adminTimeOffRequestSlice = createSlice({
  name: "adminTimeOffRequest",
  initialState,
  reducers: {
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateTimeOffTypeFilters: (state, action) => {
      state.timeOffTypeFilters = action.payload;
    },
    updateStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateAdminTimeOffRequestFoundByReferenceNumberSearch: (state, action) => {
      state.adminTimeOffRequestFoundByReferenceNumberSearch = action.payload;
    },
    updateAdminTimeOffRequestFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.adminTimeOffRequestFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateAdminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.adminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearAllAdminTimeOffRequestFilters: () => initialState,
  },
});

export const {
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateTimeOffTypeFilters,
  updateStatusFilters,
  updateSearchString,
  updateAdminTimeOffRequestFoundByReferenceNumberSearch,
  updateAdminTimeOffRequestFoundByReferenceNumberSearchIsLoading,
  updateAdminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  clearAllAdminTimeOffRequestFilters,
} = adminTimeOffRequestSlice.actions;

export const selectAdminTimeOffRequestData = (state) => state.adminTimeOffRequest;

export default adminTimeOffRequestSlice.reducer;
